/**
 * Post-signup welcome step gating (#496).
 *
 * "Show exactly once per user" without a server-side settings store:
 * the completion flag is per-user in localStorage (refresh-safe), and
 * eligibility is additionally gated on the Cognito signupDate claim —
 * only accounts younger than the window can ever see the welcome, so
 * existing users never get it retrofitted onto a new device.
 */

const KEY_PREFIX = 'systemdox.welcomeSeen.';
const ELIGIBLE_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export function hasSeenWelcome(userId: string): boolean {
  try {
    return localStorage.getItem(KEY_PREFIX + userId) === '1';
  } catch {
    return true; // storage blocked — never loop the user through welcome
  }
}

export function markWelcomeSeen(userId: string): void {
  try {
    localStorage.setItem(KEY_PREFIX + userId, '1');
  } catch {
    // ignore
  }
}

export function shouldShowWelcome(user: { userId?: string; signupDate?: string } | null): boolean {
  if (!user?.userId) return false;
  if (hasSeenWelcome(user.userId)) return false;
  if (!user.signupDate) return false;
  const signedUp = Date.parse(user.signupDate);
  if (Number.isNaN(signedUp)) return false;
  return Date.now() - signedUp < ELIGIBLE_WINDOW_MS;
}
